<template>
  <generic-modal
    size="tiny"
    :title="$t('calendar configuration')"
    icon="settings"
    image="/images/icons/calendar.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    :on_finished="finished"
  >
    <div class="description">
      <div class="ui form">
        <div class="ui top attached tabular menu" ref="tabs">
          <a class="active item" data-tab="general"
            ><i class="info ion"></i> {{ $t("general") }}</a
          >
          <a class="item" data-tab="group">
            <i class="group"></i> {{ $t("groups") }}
          </a>
        </div>
        <div class="ui active bottom attached segment" data-tab="general">
          gen
        </div>
        <div class="ui bottom attached tab segment" data-tab="group">group</div>

        <h4 class="ui dividing header">{{ $t("business hours") }}</h4>
        <div class="fields">
          <div class="eight wide field">
            <label>{{ $t("start time") }}</label>
            <div class="ui calendar" ref="start_date">
              <div class="ui input left icon">
                <i class="clock icon"></i>
                <input type="text" name="start_time" />
              </div>
            </div>
          </div>
          <div class="eight wide field">
            <label>{{ $t("end time") }}</label>
            <div class="ui calendar" ref="end_date">
              <div class="ui input left icon">
                <i class="clock icon"></i>
                <input type="text" name="end_time" />
              </div>
            </div>
          </div>
        </div>
        <div class="field">
          <label>{{ $t("working days") }}</label>
          <div class="ui multiple selection dropdown" ref="working_days">
            <div class="text">{{ $t("select days") }}</div>
            <i class="dropdown icon"></i>
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
import moment from "moment";

export default {
  name: "CalendarConfigurationModal",
  components: {
    "generic-modal": GenericModal,
  },
  computed: {},
  data() {
    return {
      configuration: {
        start_time: "",
        end_time: "",
        working_days: "",
      },
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        local_api(vm, "post", "/calendar/configuration/do-save", {
          s: vm.configuration,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/calendar/configuration/do-get")
      .then((conf) => {
        window.jQuery(vm.$refs.start_date).calendar({
          endCalendar: window.jQuery(vm.$refs.end_date),
          type: "time",
          onChange(value) {
            vm.configuration.start_time = moment(value).format("HH:mm");
          },
        });

        window.jQuery(vm.$refs.end_date).calendar({
          startCalendar: window.jQuery(vm.$refs.start_date),
          type: "time",
          onChange(value) {
            vm.configuration.end_time = moment(value).format("HH:mm");
          },
        });

        let days = [
          { name: "monday", value: 1 },
          { name: "tuesday", value: 2 },
          { name: "wednesday", value: 3 },
          { name: "thursday", value: 4 },
          { name: "friday", value: 5 },
          { name: "saturday", value: 6 },
          { name: "sunday", value: 0 },
        ];
        let dayValues = days.map((d) => {
          return { name: vm.$t(d.name), value: d.value };
        });

        window
          .jQuery(vm.$refs.working_days)
          .dropdown("setup menu", { values: dayValues })
          .dropdown({
            onChange(value) {
              vm.configuration.working_days = value;
            },
          });

        // console.log("conf", conf);

        if (conf && conf.start_time)
          window
            .jQuery(vm.$refs.start_date)
            .calendar("set date", conf.start_time);
        if (conf && conf.end_time)
          window.jQuery(vm.$refs.end_date).calendar("set date", conf.end_time);
        if (conf && conf.working_days) {
          let wrkngDays = conf.working_days.split(",");
          window
            .jQuery(vm.$refs.working_days)
            .dropdown("set selected", wrkngDays);

          window.jQuery(vm.$refs.tabs).find(".item").tab();
        }
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {},
  updated: function () {},
};
</script>
